class validationAdminService {
    static sanitizeInput(input) {
        return input
        .trim()
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
        .substring(0, 255)  // Limit length

    }
    static adminSignInValidation(data){
        const errors ={}

        if(!data.email?.trim()){
            errors.email = "Email Id is required"
        }
        else if(!this.isValidEmail(data.email)){
            errors.email = 'Please enter a valid email address';
        }
        if(!data.password?.trim()){
            errors.password = "Password Required "
        }else if (data.password.length < 6) {
            errors.password = "Password must be at least 6 characters";
        } 
       
        // const email = this.sanitizeInput(data.email);
        // const password = this.sanitizeInput(data.password);
        
        // if (!this.isValidEmail(email)) {
        //     errors.email = 'Please enter a valid email address';
        // }
        
        // if (!password || password.length < 6) {
        //     errors.password = 'Password must be at least 6 characters';
        // }
        return errors
    }

    static isValidEmail(email){
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email)
    }
    
}
export const validateAdminForm = validationAdminService